<template>
  <div class="modal">
    <div class="modal__mask" @click="closeModal">
      <div class="modal__wrapper" @click.stop>
        <div class="modal__container">
          <div class="modal__header">
            <div class="modal__title">{{ modalName }}</div>
            <div
              class="modal__close"
              @click="closeModal"
            ></div>
          </div>

          <div class="modal__body">
            <div class="emails-container" v-if="emails.length > 0">
              <div class="email-card" v-for="(email, index) in emails" :key="index">
                <div class="email-header">
                  <div class="email-meta">
                    <div class="email-from">
                      <span class="label">From:</span>
                      <span class="value">{{ JSON.parse(email.email)["From"] }}</span>
                    </div>
                    <div class="email-date">
                      <span class="label">Date:</span>
                      <span class="value">{{ formatToUS(JSON.parse(email.email)["Date"]) }}</span>
                      <!-- <span class="value">{{ JSON.parse(email.email)["Date"] }}</span> -->
                    </div>
                  </div>
                  <div class="email-subject">
                    <span class="label">Subject:</span>
                    <span class="value">{{ JSON.parse(email.email)["Subject"] }}</span>
                  </div>
                </div>
                
                <div class="email-body">
                  <div class="email-body-header">
                    <span class="label">Message:</span>
                    <button 
                      type="button"
                      class="toggle-button" 
                      @click="toggleEmailExpand(index)"
                      :class="{ 'expanded': expandedEmails[index] }"
                    >
                      {{ expandedEmails[index] ? 'Collapse' : 'Expand' }}
                      <svg class="toggle-icon" :class="{ 'rotated': expandedEmails[index] }" viewBox="0 0 24 24" width="16" height="16">
                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                      </svg>
                    </button>
                  </div>
                  
                  <div class="email-content" :class="{ 'expanded': expandedEmails[index] }">
                    <div class="email-text" v-html="JSON.parse(email.email)['body-html']"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="no-emails" v-else>
              <div class="no-emails-icon">📧</div>
              <div class="no-emails-text">No emails received.</div>
            </div>
          </div>

          <div class="modal__footer">
            <div
              class="modal__close-button"
              @click="closeModal"
            >
              <div class="close-button__img"></div>
              <span>Close</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EmailReceivedPopUp",
  components: {
  },
  props: {
    // open: Boolean,
    emails: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["showStatus"],
  data: function () {
    return {
      modalName: "Emails Received",
      expandedEmails: [], // Track which emails are expanded - use array instead of object
    };
  },
  watch: {
    emails: {
      handler(newEmails) {
        // Initialize expanded state when emails change
        this.expandedEmails = new Array(newEmails.length).fill(false);
      },
      immediate: true
    }
  },
  created() {
    // Initialize expanded state for existing emails
    this.expandedEmails = new Array(this.emails.length).fill(false);
  },
  mounted() {
    this.getEmailPreview();
  },
  computed: {
  },
  methods: {
    getEmailPreview() {
      
    },
    formatToUS(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/Los_Angeles'
      });
    },
    
    toggleEmailExpand(index) {
      const newExpandedEmails = [...this.expandedEmails];
      newExpandedEmails[index] = !newExpandedEmails[index];
      this.expandedEmails = newExpandedEmails;
      this.$forceUpdate();
    },
    closeModal() {
      this.$emit('showStatus', false);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Modal styles */
.modal {
  position: absolute;
}

.modal__mask {
  position: fixed;
  z-index: 110;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  transition: opacity 0.3s ease;
  padding: 20px;
  overflow-y: auto;
}

.modal__wrapper {
  width: 100%;
  max-width: 900px;
  margin: 40px auto;
  overflow-y: visible;
}

.modal__container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-family: "Lato", Helvetica, Arial, sans-serif;
  width: 100%;
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}

.modal__header {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e1e8ed;
  padding: 20px 30px;
  background: #f8fafb;
  border-radius: 8px 8px 0 0;
}

.modal__title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  color: #2d3757;
  margin: 0;
}

.modal__close {
  position: absolute;
  top: 20px;
  right: 30px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: url(@/assets/close.svg) no-repeat center center;
  background-size: 16px 16px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal__close:hover {
  background-color: #f0f0f0;
}

.modal__body {
  flex: 1;
  padding: 0;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
  border-top: 1px solid #e1e8ed;
  background: #f8fafb;
  border-radius: 0 0 8px 8px;
}

/* Email Cards */
.emails-container {
  padding: 20px;
  gap: 16px;
  display: flex;
  flex-direction: column;
}

.email-card {
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  overflow: hidden;
}

.email-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.email-header {
  padding: 20px;
  background: #f8fafb;
  border-bottom: 1px solid #e1e8ed;
}

.email-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 16px;
}

.email-from,
.email-date {
  display: flex;
  align-items: center;
  gap: 8px;
}

.email-subject {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  word-break: break-word;
}

.label {
  font-weight: 600;
  color: #64748b;
  font-size: 14px;
  min-width: fit-content;
}

.value {
  color: #2d3757;
  font-size: 14px;
  word-break: break-word;
}

.email-subject .value {
  font-weight: 500;
  font-size: 16px;
}

/* Email Body */
.email-body {
  background: #fff;
}

.email-body-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
  z-index: 10;
  position: relative;
}

.toggle-button:hover {
  background: #f1f5f9;
  border-color: #9ca3af;
  color: #374151;
}

.toggle-button.expanded {
  background: #2d3757;
  border-color: #2d3757;
  color: white;
}

.toggle-icon {
  fill: currentColor;
  transition: transform 0.2s ease;
}

.toggle-icon.rotated {
  transform: rotate(180deg);
}

.email-content {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  max-height: 80px;
  position: relative;
}

.email-content.expanded {
  max-height: 2000px;
  transition: max-height 0.5s ease-in-out;
}

.email-text {
  padding: 20px;
  color: #374151;
  line-height: 1.6;
  font-size: 14px;
}

.email-content:not(.expanded)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
  pointer-events: none;
  z-index: 1;
}

/* No emails state */
.no-emails {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
}

.no-emails-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.no-emails-text {
  font-size: 16px;
  font-weight: 500;
}

/* Button Styles */
.modal__close-button {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  transition: all 0.2s ease;
  background: white;
  color: #374151;
  font-weight: 500;
}

.modal__close-button:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.close-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/btn-close.svg) no-repeat center center;
  margin-right: 8px;
  opacity: 0.7;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .modal__wrapper {
    margin: 20px auto;
    padding: 0 10px;
  }
  
  .modal__container {
    max-height: calc(100vh - 40px);
  }
  
  .email-meta {
    flex-direction: column;
    gap: 8px;
  }
  
  .email-from,
  .email-date,
  .email-subject {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .email-body-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .toggle-button {
    align-self: flex-end;
  }
}

/* Custom scrollbar */
.modal__body::-webkit-scrollbar {
  width: 6px;
}

.modal__body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.modal__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.modal__body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Email HTML content styling */
.email-text ::v-deep p {
  margin: 0 0 12px 0;
}

.email-text ::v-deep br {
  margin-bottom: 8px;
}

.email-text ::v-deep a {
  color: #3b82f6;
  text-decoration: underline;
}

.email-text ::v-deep blockquote {
  border-left: 3px solid #e5e7eb;
  padding-left: 16px;
  margin: 16px 0;
  color: #6b7280;
  font-style: italic;
}
</style>